import React, { useEffect, useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import { Query, Subscription, useApolloClient } from 'react-apollo';
import { GET_STUDENT_CONVOS_SMS, GET_USER_SMS_CONVO } from 'graphql/conversations';
import Spin from 'components/common/Spin';
import Room from './Room';
import { useSelector } from 'react-redux';
import { getFullName } from 'utils';
import useSnack from 'hooks/useSnack';
import { Box, Typography } from '@material-ui/core';

const WrappedConversation = ({ userSub, student }) => {
  const user = useSelector((s) => s.user.user);
  const [convoUser, setConvoUser] = useState();
  const [loading, setLoading] = useState(false);
  const [noPhone, setNoPhone] = useState();
  const [convo, setConvo] = useState();
  const client = useApolloClient();
  const snack = useSnack();

  useEffect(() => {
    setLoading(true);
    setConvo();
    setNoPhone();
    setConvoUser();
    client
      .query({
        query: GET_USER_SMS_CONVO,
        variables: {
          sub: userSub,
        },
        fetchPolicy: 'network-only',
      })
      .then(
        (resp) => {
          const { data } = resp;
          const c = data.convo;
          setConvo(c);
          setConvoUser(data.users[0]);
          if (!data.users[0].user_phone) {
            setNoPhone(true);
          } else {
            setNoPhone(false);
          }
          setLoading(false);
        },
        (e) => {
          snack.error(e.message);
        },
      );
  }, [userSub]);

  if (loading) return <Spin spinning linear />;

  if (noPhone && !convo) {
    return (
      <Box padding={4} textAlign="center">
        <Typography gutterBottom variant="body1">
          User has no phone number.
        </Typography>
      </Box>
    );
  }

  if (!convo)
    return (
      <Box padding={4} textAlign="center">
        No conversation.
      </Box>
    );

  return (
      <Room
        disabled={noPhone}
        user={user}
        match={{
          params: {
            id: convo.convo_id,
            type: 'sms',
          },
        }}
      />
  );
};

const TextHistory = ({
  match: {
    params: { id },
  },
}) => {
  const [tab, setTab] = useState(0);
  const user = useSelector((state) => state.user.user);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };
  return (
    <div>
      <Subscription
        subscription={GET_STUDENT_CONVOS_SMS}
        variables={{ userId: id }}
      >
        {({ data, loading }) => {
          if (loading) return <Spin spinning />;
          const { student } = data;

          return (
            <>
              <Paper>
                <Tabs
                  indicatorColor="primary"
                  textColor="primary"
                  value={tab}
                  onChange={handleTabChange}
                >
                  <Tab key={student.sub} label={getFullName(student)} />
                </Tabs>
                {student.sub ? (
                  <Box >
                    <WrappedConversation
                      userSub={student.sub}
                      student={student}
                    />
                  </Box>
                ) : null}
                {/* <Query
                  query={GET_USER_SMS_CONVO}
                  variables={{ sub: student.sub }}
                  fetchPolicy="network-only"
                >
                  {({ data, loading }) => {
                    if (loading) return <Spin spinning />;
                    const c = data.convo;
                    setConvo(c);
                    setConvoUser(data.users[0]);
                    if (!data.users[0].user_phone) {
                      setNoPhone(true);
                    } else {
                      setNoPhone(false);
                    }
                    setLoading(false);
                    return <></>;
                  }}
                </Query> */}
                {/* <Room room={rooms[tab]} /> */}
              </Paper>
            </>
          );
        }}
      </Subscription>
    </div>
  );
};

export default TextHistory;
